import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { SharedModule } from '../../../shared/shared.module';
import { UserRole } from '../../enums/user-role.enum';
import { UserInterface } from '../../models/user.model';
import { SonataSessionService } from '../../services/sonata-session/sonata-session.service';
import { ImpersonateService } from '../impersonate.service';

@Component({
  selector: 'app-unimpersonate',
  templateUrl: './unimpersonate.component.html',
  styleUrls: ['./unimpersonate.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule],
})
export class UnimpersonateComponent implements OnInit {
  private impersonateService = inject(ImpersonateService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private sonataSessionService = inject(SonataSessionService);

  visible = false;

  ngOnInit() {
    this.authService.authenticatedObservable().subscribe((authenticated: boolean) => {
      const user = this.authService.getRealUser();
      this.visible = authenticated && user && user.role && user.role.name === UserRole.ROLE_ADMIN && this.impersonateService.impersonated();
    });
  }

  unimpersonate() {
    this.impersonateService.unImpersonate();
    const user: UserInterface = this.authService.getUser();
    if (user && user.role && user.role.name === UserRole.ROLE_ADMIN && user.redirect) {
      this.sonataSessionService.openRedirect(user.redirect);
    } else {
      this.authService.logout();
    }
  }
}
